export default "__VITE_ASSET__knzdWTzT__"